import { render } from "./ModalFairSeed.vue?vue&type=template&id=200e7051&scoped=true"
import script from "./ModalFairSeed.vue?vue&type=script&lang=js"
export * from "./ModalFairSeed.vue?vue&type=script&lang=js"

import "./ModalFairSeed.vue?vue&type=style&index=0&id=200e7051&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200e7051"]])

export default __exports__